import { useState, useEffect } from "react";
import { Box } from "@mui/system";
import CircularProgress from "@mui/material/CircularProgress";
import FullScreenDialog from "../FullScreenDialog/FullScreenDialog";

export default function LessonDialog({ lesson, ...dialogProps }) {
  const [isLoading, setIsLoading] = useState(false);

  let embedLink;
  if (lesson) {
    lesson.embed_id = lesson.embed_id?.replace("2PACX-1v", "");
    if (lesson.embed_link) {
      embedLink = lesson.embed_link;
    } else if (lesson.type === "doc") {
      embedLink = `https://docs.google.com/document/d/e/2PACX-1v${lesson.embed_id}/pub?embedded=true`;
    } else if (lesson.type === "file") {
      embedLink = `https://drive.google.com/file/d/${lesson.embed_id}/preview`;
    } else {
      embedLink = `https://docs.google.com/spreadsheets/d/e/2PACX-1v${lesson.embed_id}/pubhtml?gid=0&amp;single=true&amp;widget=true&amp;headers=false`;
    }
  }

  // whenever embedLink changes, start loader
  useEffect(() => {
    if (embedLink) {
      setIsLoading(true);
    }
  }, [embedLink]);

  return (
    <FullScreenDialog {...dialogProps} title={lesson?.name} disablePadding>
      {embedLink && (
        <Box
          sx={{
            position: "relative",
            width: "100%",
            display: "flex",
            justifyContent: "center",
            height: "100%",
          }}
        >
          {isLoading && (
            <Box
              sx={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: "rgba(255,255,255,0.7)",
                zIndex: 1,
              }}
            >
              <CircularProgress />
            </Box>
          )}

          <Box
            sx={{
              width: "100%",
              maxWidth: 800,
              height: "100%",
              zIndex: 0,
            }}
          >
            <iframe
              id="doc-view-frame"
              className="embedded-doc"
              src={embedLink}
              width="100%"
              height="100%"
              style={{ border: 0 }}
              onLoad={() => setIsLoading(false)}
            />
          </Box>
        </Box>
      )}
    </FullScreenDialog>
  );
}
